import React from "react";

import { Link, useLocation } from "react-router-dom";

import {
  SignalIcon,
  FingerPrintIcon,
  WrenchIcon,
} from "@heroicons/react/24/outline";

import { ReactComponent as DermiLogoIcon } from "./Icons/dermi_logo.svg";

const Header = () => {
  const location = useLocation();

  const authPathPatterns = [
    "/login",
    "/email_registration",
    "/complete_registration/:user_id/:token/:user_email",
    "/email_reset_request",
    "/password_reset/:user_id/:token/:user_email/:username",
  ];

  // This function takes a pathname as an argument and checks if it matches any of the authPathPatterns.
  const isAuthPath = (pathname) => {
    // Split the pathname by slashes to get an array of path elements.
    const pathElements = pathname.split("/");
    // Check if any of the patterns in authPathPatterns match the current pathname.
    return authPathPatterns.some((pattern) => {
      // Split the pattern by slashes to get an array of pattern elements.
      const patternElements = pattern.split("/");
      // If the number of elements in the pathname and pattern is different, they can't match, so return false.
      if (pathElements.length !== patternElements.length) return false;
      // Check if all elements in the pattern match the corresponding elements in the pathname.
      return patternElements.every((element, index) => {
        // If the pattern element starts with a colon, it's a route parameter and can match any value, so return true.
        if (element.startsWith(":")) return true;
        // If the pattern element is not a route parameter, check if it's equal to the corresponding element in the pathname.
        return element === pathElements[index];
      });
    });
  };

  const NavButton = ({ Icon, pageLink, isNavActive }) => {
    return (
      <Link to={pageLink}>
        <div
          className={`flex flex-row items-center justify-center p-2 rounded-lg 
                    bg-white hover:bg-neutral-50 active:bg-teal-100
                      border border-1 border-neutral-300
                      ${isNavActive && "border-neutral-500"}
                    `}
        >
          <div className="flex items-center justify-center h-10 w-10 rounded-md Xbg-red-500">
            <Icon className="text-black w-7 h-7 Xbg-blue-500" />
          </div>
        </div>
      </Link>
    );
  };

  return (
    <>
      <div className="top-0 left-0 z-[45] fixed flex flex-row items-center justify-center w-full Xbg-pink-500">
        <div
          className={`flex flex-row items-center justify-between w-full p-2 Xbg-orange-500`}
        >
          <div className="flex flex-row items-center justify-start w-full space-x-2 Xbg-red-500">
            <DermiLogoIcon className="bg-whiteX w-14 h-14 cursor-pointer transition-all duration-150 hover:rotate-12" />
          </div>
          <div className="flex flex-row items-center justify-end w-full space-x-2 Xbg-blue-500">
            <NavButton
              Icon={WrenchIcon}
              pageLink={"/reset_state"}
              isNavActive={"/reset_state" === location.pathname}
            />
            <NavButton
              Icon={SignalIcon}
              pageLink={"/server_configuration"}
              isNavActive={"/server_configuration" === location.pathname}
            />
            <NavButton
              Icon={FingerPrintIcon}
              pageLink={"/login"}
              isNavActive={isAuthPath(location.pathname)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
